import request from '@/axios'
import type { UserType, CodeType } from './types'

interface RoleParams {
  roleName: string
}

export const loginApi = (data: UserType): Promise<IResponse<UserType>> => {
  return request.post({ url: '/auth/login', data })
}

export const sendCodeApi = (data: CodeType): Promise<IResponse<CodeType>> => {
  return request.post({ url: '/auth/regCaptcha', data })
}

export const getUserInfo = (): Promise<IResponse> => {
  return request.get({ url: '/auth/info' })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.post({ url: '/auth/logout' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/admin/menu/getRouters', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}
